import type { Workspace, PortalView } from "./types";

/* Client mirror of api/src/reporting/portal.ts — used to build the shareable
 * view locally in demo mode (no API) so a generated portal link renders. */

const STATUS_LABEL: Record<string, string> = { good: "On track", watch: "Needs attention", risk: "At risk" };

export function buildPortalView(ws: Workspace, accountId: string): PortalView | undefined {
  const a = ws.accounts.find((x) => x.id === accountId);
  if (!a) return undefined;
  const csm = ws.users.find((u) => u.id === a.ownerId)?.name ?? "Your Customer Success team";
  const sigs = ws.signals.filter((s) => s.accountId === accountId);
  const plan = ws.successPlans.find((p) => p.accountId === accountId);
  const rn = ws.renewals.find((r) => r.accountId === accountId);
  const npsIds = new Set(ws.surveys.filter((s) => s.type === "nps").map((s) => s.id));
  const npsRs = ws.surveyResponses.filter((r) => npsIds.has(r.surveyId) && r.accountId === accountId);
  const nps = npsRs.length ? Math.round(((npsRs.filter((r) => r.score >= 9).length - npsRs.filter((r) => r.score <= 6).length) / npsRs.length) * 100) : null;
  return {
    accountName: a.name,
    csmName: csm,
    generatedAt: new Date().toISOString(),
    status: { band: a.healthBand, label: STATUS_LABEL[a.healthBand] ?? a.healthBand },
    adoption: { seats: a.seats, seatsActive: a.seatsActive, utilization: a.seats ? Math.round((a.seatsActive / a.seats) * 100) : 0 },
    successPlan: plan ? { title: plan.title, outcome: plan.outcome, objectives: plan.objectives.map((o) => ({ title: o.title, status: o.status })) } : undefined,
    renewalDate: rn?.renewalDate ?? a.renewalDate,
    nps,
    wins: sigs.filter((s) => s.band === "positive").map((s) => s.title),
    focusAreas: sigs.filter((s) => s.band !== "positive").map((s) => s.title),
  };
}
